var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-class"},[_c('div',{staticClass:"row"},[_c('div',{staticStyle:{"width":"100%","float":"left","text-align":"center"}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"headerImageClass",attrs:{"alt":"Don Quijote Recepciones","src":"https://presupuesto.donquijoterecepciones.com/assets/logo-white.png"}})])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58cbc06b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Index.vue
// module id = 172
// module chunks = 0